<div class="operator-group-members-container">
    <div class="header">
        <button mat-icon-button (click)="goBack()" class="back-button">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <div class="header-content">
            <h1>
                {{ operatorGroup?.name || 'Loading...' }} Members
                @if (operatorGroup && operatorGroup.role) {
                <span class="role-badge" [class]="'role-' + operatorGroup.role">
                    {{ operatorGroup.role }}
                </span>
                }
            </h1>
            @if (customer) {
            <p class="customer-info">
                <mat-icon class="info-icon">business</mat-icon>
                {{ customer.name }}
            </p>
            }
        </div>
    </div>

    @if (isLoading) {
    <div class="loading-container">
        <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
        <p>Loading group members...</p>
    </div>
    } @else {
    <jjames-card>
        <div class="members-summary">
            <div class="summary-item">
                <mat-icon>group</mat-icon>
                <div>
                    <span class="summary-value">{{ operators.length }}</span>
                    <span class="summary-label">Active Members</span>
                </div>
            </div>
            @if (operatorGroup) {
            <div class="summary-item">
                <mat-icon>assignment</mat-icon>
                <div>
                    <span class="summary-value">{{ operatorGroup.assignedParkingSpaceCount || 0 }}</span>
                    <span class="summary-label">Assigned Parking Spaces</span>
                </div>
            </div>
            }
        </div>
    </jjames-card>

    @if (operators.length === 0) {
    <jjames-card>
        <div class="empty-state">
            <mat-icon class="empty-icon">group_off</mat-icon>
            <h2>No Members</h2>
            <p>This operator group doesn't have any active members yet.</p>
            <jjames-button [variant]="'secondary'" (clicked)="goBack()">
                Go Back
            </jjames-button>
        </div>
    </jjames-card>
    } @else {
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        @for (operator of operators; track operator.id) {
        <div class="bg-white rounded-xl border border-gray-200 p-4 flex items-center gap-4 cursor-pointer hover:shadow-md hover:border-blue-300 transition-all"
            (click)="onViewOperatorDetails(operator)">
            <div class="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center shrink-0">
                <mat-icon class="text-blue-600">person</mat-icon>
            </div>
            <div class="min-w-0">
                <p class="font-medium text-gray-900 truncate">{{ operator.firstName }} {{ operator.lastName }}</p>
                <p class="text-sm text-gray-500 truncate">{{ operator.email }}</p>
            </div>
            <mat-icon class="text-gray-400 ml-auto shrink-0">chevron_right</mat-icon>
        </div>
        }
    </div>
    }
    }
</div>